import { XMarkIcon } from '@heroicons/react/16/solid';
import { useTimeout } from 'ahooks';
import { Alert, Button, Toast } from 'react-daisyui';
import { tAdvanceSearchLead } from '../../../../components/AdvanceSearch/AdvanceSearchModal.types';
import useOpenLeadChat from '../../../../components/ChatModal/useOpenLeadChat.hook';
import {
  eChannelType,
  eMessageContentTypeLegacy,
} from '../../../../providers/SocketsProvider/Sockets.enums';
import { useLayoutContext } from '../../../../providers/LayoutProvider/Layout.context';
import { eLeadbotState } from '../../../MessengerV2/Messenger.enum';

export default function MessageNotification() {
  const { messageNotification, setMessageNotification } = useLayoutContext();
  const openLeadChat = useOpenLeadChat();

  useTimeout(() => setMessageNotification(null), 7000);

  const isImage =
    messageNotification?.message_type === eMessageContentTypeLegacy.IMAGE;
  const isDocument =
    messageNotification?.message_type === eMessageContentTypeLegacy.DOCUMENT;
  const isVideo =
    messageNotification?.message_type === eMessageContentTypeLegacy.VIDEO;
  const isAudio =
    messageNotification?.message_type === eMessageContentTypeLegacy.AUDIO;
  const isLocation =
    messageNotification?.message_type === eMessageContentTypeLegacy.LOCATION;
  const isContact =
    messageNotification?.message_type === eMessageContentTypeLegacy.CONTACT;
  const isSticker =
    messageNotification?.message_type === eMessageContentTypeLegacy.STICKER;

  const toasterBodyEmoji =
    (isImage && '🌉') ||
    (isDocument && '📄') ||
    (isVideo && '📹') ||
    (isAudio && '🎤') ||
    (isLocation && '📍') ||
    (isContact && '🧑‍🚀') ||
    (isSticker && '💟') ||
    '';

  const toasterBodyText =
    messageNotification?.message ||
    (isImage && 'Image') ||
    (isDocument && 'Document') ||
    (isVideo && 'Video') ||
    (isAudio && 'Audio') ||
    (isLocation && 'Location') ||
    (isContact && 'Contact') ||
    (isSticker && 'Sticker') ||
    '';

  const toasterBody = `${toasterBodyEmoji} ${toasterBodyText}`;

  function openChatModal() {
    if (messageNotification) {
      // Over the current page; it used to take the user to the funnel first (AGI-761).
      openLeadChat({
        id: messageNotification.lead_uuid,
        name: messageNotification.lead_name ?? '',
        email: '',
        company: '',
        value: 0,
        revenue: 0,
        profilePicture: null,
        hasCalendarEvent: false,
        tags: [],
        leadbotState: eLeadbotState.NONE,
        chat: {
          chatID: '',
          integration:
            messageNotification.channel_type || eChannelType.WHATSAPP_WEB,
          read: false,
          unreadCount: 1,
          lastMessageOn: null,
          lastMessageText: null,
          lastMessageType: null,
        },
      } satisfies tAdvanceSearchLead);
    }
    setMessageNotification(null);
  }

  return (
    <Toast
      key={messageNotification?.message_on}
      vertical="bottom"
      horizontal="end"
      className="z-50 cursor-pointer"
    >
      <audio autoPlay src="/notification.mpeg" hidden />
      <Alert status="info">
        <section
          className="min-w-48 max-w-sm cursor-pointer"
          onClick={openChatModal}
        >
          <p className="font-bold text-sm mb-2">
            {messageNotification?.lead_name}
          </p>
          <p className="text-xs overflow-ellipsis truncate">{toasterBody}</p>
        </section>
        <Button shape="circle" size="xs" color="ghost">
          <XMarkIcon
            onClick={() => {
              setMessageNotification(null);
            }}
            className="w-5"
          />
        </Button>
      </Alert>
    </Toast>
  );
}
